const Pagination = ({ items, pageSize, currentPage, baseUrl }) => {
  const pagesCount = Math.ceil(items / pageSize);

  if (pagesCount === 1) return null;

  let startPage = Math.max(1, currentPage - 2);
  let endPage = Math.min(pagesCount, startPage + 3);
  startPage = Math.max(1, endPage - 3);

  let pages = Array.from(
    { length: endPage - startPage + 1 },
    (_, i) => startPage + i
  );

  return (
    <div>
      <ul className="pagination">
        {/* left button */}
        {currentPage > 1 && (
          <li>
            <a
              className="pageItem pageLink"
              href={`${baseUrl}/${currentPage - 1}`}
            >
              &lt;
            </a>
          </li>
        )}

        {/* page number */}
        {pages.map((page) => (
          <li key={page}>
            <a
              className={`${
                page === currentPage ? "pageItemActive" : "pageItem"
              } pageLink`}
              href={`${baseUrl + (page > 1 ? "/" + page : "")}`}
            >
              {page}
            </a>
          </li>
        ))}

        {/* right button */}
        {currentPage < pagesCount && (
          <li>
            <a
              className="pageItem pageLink"
              href={`${baseUrl}/${currentPage + 1}`}
            >
              &gt;
            </a>
          </li>
        )}
      </ul>
    </div>
  );
};

export default Pagination;
